import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isLoadingImport: false,
  isLoadingGrade: false,
  isLoadingAbsence: false,
  isLoadingCourse: false,
  isLoadingGroup: false,
  isSuccess: false,
  courseData: [],
  courseBySpecialityData: [],
  groupData: [],
  gradeData: [],
  absenceData: [],
  error: '',
  errorImport: '',
  percentage: 0,
}

//Begin

export const getGroupByTeacherCourse = createAsyncThunk(
  'course/getGroupByTeacherCourse',
  async ({ ID_SPE, ID_SEM, ID_MAT, ID_ENS }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/groupByTeacherCourse`, {
        params: {
          ID_SPE,
          ID_SEM,
          ID_MAT,
          ID_ENS,
        },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const updateGradesByTeacherCourse = createAsyncThunk(
  'course/updateGradesByTeacherCourse',
  async ({ currentGrades, common, importMode, page, lang }, thunkAPI) => {
    try {
      //console.log(currentGrades, common, importMode, page, lang)
      const token = await thunkAPI.getState().auth.teacher.token
      const res1 = await request(token).put(`/teachers/gradeByTeacherCourse`, {
        currentGrades,
        common,
        importMode,
        page,
      })
      const message =
        lang === 'Français'
          ? res1.data.rowUpdated + ' note(s) modifiée(s)'
          : res1.data.rowUpdated + ' grades(s) updated'
      toast.success(message)
      //console.log(currentGrades)
      /*const res = await request.get(`/student/gradesByStudent`, {
        params: { matricule: currentGrades[0].MATRICULE, id_spe: currentGrades[0].ID_SPE },
      })*/
      const data = await res1.data
      return data
    } catch (err) {
      //console.log(err)
      const message =
        lang === 'Français'
          ? err.response.data.rowUpdated +
            '/' +
            (err.response.data.rowUpdated + err.response.data.errorCount).toString() +
            ' notes(s) modifiée(s)'
          : err.response.data.rowUpdated +
            '/' +
            (err.response.data.rowUpdated + err.response.data.errorCount).toString() +
            ' grade(s) updated'
      toast.info(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const getGradeByTeacherCourse = createAsyncThunk(
  'course/getGradeByTeacherCourse',
  async ({ ID_SPE, ID_SEM, ID_MAT, GROUPE_ETU, ID_ENS }, thunkAPI) => {
    try {
      //console.log(ID_SPE, ID_SEM, ID_MAT, GROUPE_ETU, ID_ENS)
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/gradeByTeacherCourse`, {
        params: { ID_SPE, ID_SEM, ID_MAT, GROUPE_ETU, ID_ENS },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const absenceByTeacherCourse = createAsyncThunk(
  'course/absenceByTeacherCourse',
  async (
    { ID_SPE, ID_MAT, ID_SEM, GROUPE_ETU, ID_ENS, DATE_ABS, ID_SEA, ID_TYPE_SEA },
    thunkAPI,
  ) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/absenceByTeacherCourse`, {
        params: { ID_SPE, ID_MAT, ID_SEM, GROUPE_ETU, ID_ENS, DATE_ABS, ID_SEA, ID_TYPE_SEA },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const getCourseByTeacherSpeciality = createAsyncThunk(
  'course/getCourseByTeacherSpeciality',
  async ({ ID_SPE, ID_ENS, ID_SEM }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res = await request(token).get(`/teachers/courseByTeacherSpeciality`, {
        params: { ID_SPE, ID_ENS, ID_SEM },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const addAbsenceByTeacherCourse = createAsyncThunk(
  'course/addAbsenceByTeacherCourse',
  async (
    {
      ID_SPE,
      ID_SEM,
      ID_MAT,
      GROUPE_ETU,
      ID_ENS,
      DATE_ABS,
      ID_SEA,
      ID_TYPE_SEA,
      ID_SAL,
      currentStudents,
      lang,
    },
    thunkAPI,
  ) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res1 = await request(token).post(`/teachers/absenceByTeacherCourse`, {
        ID_SPE,
        ID_SEM,
        ID_MAT,
        GROUPE_ETU,
        ID_ENS,
        DATE_ABS,
        ID_SEA,
        ID_TYPE_SEA,
        ID_SAL,
        currentStudents,
        lang,
      })
      const message =
        lang === 'Français'
          ? res1.data.rowUpdated + ' absence(s) ajoutée(s) avec succès'
          : res1.data.rowUpdated + ' absences(s) added successfully'
      toast.success(message)

      const data = await res1.data
      return data
    } catch (err) {
      console.log(err)
      const message =
        lang === 'Français'
          ? err.response.data.rowUpdated +
            '/' +
            (err.response.data.rowUpdated + err.response.data.errorCount).toString() +
            ' absence(s) ajoutée(s) à jour avec succès'
          : err.response.data.rowUpdated +
            '/' +
            (err.response.data.rowUpdated + err.response.data.errorCount).toString() +
            ' absence(s) added successfully'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const deleteAbsenceByTeacherCourse = createAsyncThunk(
  'course/deleteAbsenceByTeacherCourse',
  async ({ ID_ABS, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.teacher.token
      const res1 = await request(token).post(`/teachers/deleteAbsenceByID`, { ID_ABS })
      const dt = await res1.data
      toast.success(
        lang === 'Français'
          ? dt?.rowDeleted + ' absence(s) annulée(s) avec succès'
          : dt?.rowDeleted + ' absence(s) successfully cancelled',
      )
      const data = await res1.data
      return childrenProps
    } catch (err) {
      const message =
        lang === 'Français'
          ? 'Erreur ! ' +
            err.response.data.errorCount +
            ' sur ' +
            childrenProps.selected.length +
            " absence(s) n'ont pas pu être annulée(s)"
          : 'Error ! ' +
            err.response.data.message.errorNum +
            ' of ' +
            childrenProps.selected.length +
            ' absence(s) could not be canceled'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCourseByTeacherSpeciality.pending, (state) => {
        return {
          ...state,
          isLoadingCourse: true,
        }
      })
      .addCase(getCourseByTeacherSpeciality.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          courseBySpecialityData: action.payload,
          isLoadingCourse: false,
          error: '',
        }
      })
      .addCase(getCourseByTeacherSpeciality.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          isLoadingCourse: false,
          error: action.error.message,
        }
      })
      .addCase(getGroupByTeacherCourse.pending, (state) => {
        return {
          ...state,
          isLoadingGroup: true,
        }
      })
      .addCase(getGroupByTeacherCourse.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          groupData: action.payload,
          isLoadingGroup: false,
          error: '',
        }
      })
      .addCase(getGroupByTeacherCourse.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          isLoadingGroup: false,
          error: action.error.message,
        }
      })
      .addCase(getGradeByTeacherCourse.pending, (state) => {
        return {
          ...state,
          isLoadingGrade: true,
        }
      })
      .addCase(getGradeByTeacherCourse.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          gradeData: action.payload,
          isLoadingGrade: false,
          error: '',
        }
      })
      .addCase(getGradeByTeacherCourse.rejected, (state, action) => {
        return {
          ...state,
          isLoadingGrade: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(absenceByTeacherCourse.pending, (state) => {
        return {
          ...state,
          isLoadingAbsence: true,
        }
      })
      .addCase(absenceByTeacherCourse.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          absenceData: action.payload,
          isLoadingAbsence: false,
          error: '',
        }
      })
      .addCase(absenceByTeacherCourse.rejected, (state, action) => {
        return {
          ...state,
          isLoadingAbsence: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(updateGradesByTeacherCourse.pending, (state) => {
        return {
          //isLoadingGrade: true,
          ...state,
        }
      })
      .addCase(updateGradesByTeacherCourse.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          //isLoadingGrade: false,
          error: '',
        }
      })
      .addCase(updateGradesByTeacherCourse.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          //isLoadingGrade: false,
          error: action.error.message,
        }
      })
      .addCase(addAbsenceByTeacherCourse.pending, (state) => {
        return {
          //isLoadingGrade: true,
          ...state,
        }
      })
      .addCase(addAbsenceByTeacherCourse.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          //isLoadingGrade: false,
          error: '',
        }
      })
      .addCase(addAbsenceByTeacherCourse.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          //isLoadingGrade: false,
          error: action.error.message,
        }
      })
      .addCase(deleteAbsenceByTeacherCourse.pending, (state) => {
        return {
          //isLoadingGrade: true,
          ...state,
        }
      })
      .addCase(deleteAbsenceByTeacherCourse.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          //isLoadingGrade: false,
          error: '',
        }
      })
      .addCase(deleteAbsenceByTeacherCourse.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          //isLoadingGrade: false,
          error: action.error.message,
        }
      })
  },
})

export default courseSlice.reducer
